<template>
    <div class="container-fluid p-0">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-8">
                <div class="back-image"
                     style="background-image: url('/storage/banner/60e3e3b545c85.png')">
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 pl-md-0">





                <div class="login-form d-flex align-items-center flex-column">


                    <form v-if="showHiddenForm" class="sign-in-sign-up-form w-100"
                          ref="form" data-url="/admin/users/registration" action="store">

                          <div class="text-center mb-4">
                              <video width="320" height="240" autoplay muted playsinline webkit-playsinline class="video-logo">
                                  <source src="/videos/onboardio_final_white_small.mp4" type="video/mp4">
                              </video>
                          </div>
                          <div class="form-row login-form-fade-in">
                              <div class="form-group col-12 mt-3 px-0">
                                  <label class="text-center d-block">Ahoy! Vytvořte si účet</label>
                              </div>
                          </div>

                          <div class="form-row login-form-fade-in">
                              <div class="form-group col-12 px-0">
                              <label for="create_email">E-mail</label>
                              <app-input id="create_email"
                                         type="email"
                                         v-model="create.email"
                                         :placeholder="$t('enter_your_email')"/>
                             </div>
                          </div>
                          <div class="form-row">
                              <div class="form-group col-12 px-0">
                              <label for="create_company">Název společnosti</label>
                              <app-input type="text"
                                          v-model="create.company"/>
                            <span v-if="create.company" style="text-transform: lowercase;">
                              <small>Na této adrese si budete moci vytvořit kariérní stránku:
                                  {{ create.company }}.onboardio.pro</small></span>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 px-0">
                              <label for="create_company">Telefon</label>
                              <app-input type="text"
                                         v-model="create.phone"/>
                            </div>
                        </div>
                        <div class=" mb-3">
                            Souhlasím s <a href="https://onboardio.cz/obchodni-podminky.html" target="_blank" class="text-muted">obchodními podmínkami</a>
                        </div>
                          <app-load-more :preloader="preloader"
                                                    :label="'Vytvořit účet'"
                                                    type="submit"
                                                    class-name="btn btn-primary btn-block text-center"
                                                    @submit="submitAccount"/>

                    </form> 



                    <form class="sign-in-sign-up-form w-100"
                          ref="form" data-url="/admin/users/login" action="store">

                        <div class="text-center mb-4">
                            <video width="320" height="240" autoplay muted playsinline webkit-playsinline class="video-logo">
                                <source src="/videos/onboardio_final_white_small.mp4" type="video/mp4">
                            </video>

                        </div>
                        <div class="form-row login-form-fade-in">
                            <div class="form-group col-12 mt-3 px-0">
                                <label v-if="this.lang == 'en'" class="text-center d-block">Log-in to your dashboard</label>
                                <label v-else-if="this.lang == 'sk'" class="text-center d-block">Vitajte! Prihláste sa prosím</label>
                                <label v-else class="text-center d-block">{{ $t('log_in_to_your_dashboard') }}</label>
                            </div>
                        </div>

                        <div v-show="!loginDetailsHide" class="form-row">
                            <div v-if="this.lang == 'en'" class="form-group col-12 px-0 login-form-fade-in">
                                <label for="login_email">E-mail address</label>
                                <app-input type="email"
                                           v-model="login.email"
                                           placeholder="Enter your e-mail"
                                           :required="true"/>
                            </div>
                            <div v-else-if="this.lang == 'sk'" class="form-group col-12 px-0 login-form-fade-in">
                                <label for="login_email">Emailová adresa</label>
                                <app-input type="email"
                                           v-model="login.email"
                                           placeholder="Zadajte svoj e-mail"
                                           :required="true"/>
                            </div>
                            <div v-else class="form-group col-12 px-0 login-form-fade-in">
                                <label for="login_email">{{ $t('email') }}</label>
                                <app-input type="email"
                                           v-model="login.email"
                                           :placeholder="$t('enter_your_email')"
                                           :required="true"/>
                            </div>
                        </div>

                        <div v-show="!passwordDetailsHide" class="form-row">
                            <div v-if="this.lang == 'en'" class="form-group col-12 px-0 login-form-fade-in">
                                <label for="login_password">Password</label>
                                <app-input type="password"
                                           v-model="login.password"
                                           :class="loginShakePassord ? 'shake' : ''"
                                           placeholder="Enter your password"
                                           :required="true"/>
                            </div>
                            <div v-else-if="this.lang == 'sk'" class="form-group col-12 px-0 login-form-fade-in">
                                <label for="login_password">Heslo</label>
                                <app-input type="password"
                                           v-model="login.password"
                                           :class="loginShakePassord ? 'shake' : ''"
                                           placeholder="Zadajte svoje heslo"
                                           :required="true"/>
                            </div>
                            <div v-else class="form-group col-12 px-0 login-form-fade-in">
                                <label for="login_password">{{ $t('password') }}</label>
                                <app-input type="password"
                                           v-model="login.password"
                                           :class="loginShakePassord ? 'shake' : ''"
                                           :placeholder="$t('enter_your_password')"
                                           :required="true"/>
                            </div>
                        </div>
                        <div class="form-row" v-if="recaptchaEnable == 1">
                            <div class="form-group col-12 px-0">
                                <re-captcha :site-key="siteKey"></re-captcha>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-12 px-0 login-form-fade-in">
                                <app-load-more :preloader="preloader"
                                               :label="submitLabel"
                                               type="submit"
                                               class-name="btn btn-primary btn-block text-center"
                                               @submit="submit"/>
                            </div>
                        </div>
                        <div
                            class="form-row form-row flex-column flex-md-row justify-content-center justify-content-md-between justify-content-lg-between login-form-fade-in">
                            <a v-if="this.lang == 'en'" href="/forget-password"
                               class="bluish-text d-flex align-items-center justify-content-center justify-content-lg-end">
                                <app-icon name="lock" class="pr-2"/> Forgotten password?
                            </a>
                            <a v-else-if="this.lang == 'sk'" href="/forget-password"
                               class="bluish-text d-flex align-items-center justify-content-center justify-content-lg-end">
                                <app-icon name="lock" class="pr-2"/> Zabudnuté heslo?
                            </a>
                            <a v-else href="/forget-password"
                               class="bluish-text d-flex align-items-center justify-content-center justify-content-lg-end">
                                <app-icon name="lock" class="pr-2"/> {{ $t('forgot_password') }}
                            </a>
                        </div>
                        <div class="form-row login-form-fade-in">
                            <div class="col-12">
                                <div class="form-row-lang">
                                    <span @click="changeLang('cs')" :class="lang == 'cs' ? 'active' : ''">Čeština</span>
                                    <span @click="changeLang('sk')" :class="lang == 'sk' ? 'active' : ''">Slovenčina</span>
                                    <span @click="changeLang('en')" :class="lang == 'en' ? 'active' : ''">English</span>
                                </div>

                            </div>


                            <div class="col-12">
                                <p class="text-center mt-5">
                                    © {{ currentYear }} Onboardio<br>
                                </p>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ThemeMixin from "../../../../core/mixins/global/ThemeMixin";
    import {AuthMixin} from "./Mixins/AuthMixin";
    export default {
        name: "Login",
        mixins: [AuthMixin, ThemeMixin],
        components: {},
        props: {
            siteKey: String,
            recaptchaEnable: {},
        },
        data() {
            return {
                login: {email: '', password: ''},
                create: {},
                showHiddenForm: false,
                loginDetailsHide: false,
                passwordDetailsHide: false,
                loginShakePassord: false,
                submitLabel: '',
                lang: 'cs',
                currentYear: '',
            };
        },
        mounted() {
            this.fillLoginDetails();
            this.checkTenancy();

            let loginLang = "";
            if(this.getCookie("loginLang")){
                loginLang = this.getCookie("loginLang");
                this.changeLang(loginLang);
            }

            this.currentYear = new Date().getFullYear();

        },
        methods: {
            submit() {
                if(this.passwordDetailsHide){
                    this.redirectToTenant(this.login.email);
                } else {
                    this.save(this.login);
                }

            },
            afterSuccess(res) {
                window.location = res.data;
            },
            submitAccount() {
                //url: 'create-new-account',
                // data: this.create
                console.log('saved '+this.create);
                this.axiosPost({
                    url: 'api/register',
                    data: this.create
                }).then(response => {
                    console.log(response+response.data+response.data.data);
                }).finally(() => {
                });
                // axios this.create
            },
            fillLoginDetails() {
                // Fill login details after registration or login from central domain
                if(window.location.href.indexOf("?u") > -1){
                    var url_string = window.location.href;
                    var url = new URL(url_string);
                    var u = url.searchParams.get("u");

                    this.login.email = u;
                    this.loginShakePassord = true;
                    let _this = this;
                    setTimeout(function(){ _this.loginShakePassord = true; }, 2000);

                }
            },
            checkTenancy() {
                let url = window.location.href;

                // Disable for main and subdomains on localhost (testing only)
                if(url.indexOf("localhost") != -1 || url.indexOf(".onboardio.pro") != -1){
                    this.passwordDetailsHide = false;

                    if(this.lang == "en"){
                        this.submitLabel = "Login";
                    } else if(this.lang == "sk"){
                        this.submitLabel = "Prihlásiť sa";
                    } else {
                        this.submitLabel = this.$t('login');
                    }

                } else {
                    this.passwordDetailsHide = true;

                    if(this.lang == "en"){
                        this.submitLabel = "Continue";
                    } else if (this.lang == "sk"){
                        this.submitLabel = "Pokračovať";
                    } else {
                        this.submitLabel = this.$t('continue');
                    }
                }


            },
            redirectToTenant(email) {
                let url = window.location.href;
                let subdomain = "";

                if(email.indexOf("@gmail") != -1 || email.indexOf("@email") != -1 || email.indexOf("@seznam") != -1 || email.indexOf("@centrum") != -1 || email.indexOf("@post") != -1 || email.indexOf("@firmy") != -1 || email.indexOf("@yahoo") != -1 || email.indexOf("@icloud") != -1 || email.indexOf("@aol") != -1 || email.indexOf("@outlook") != -1 || email.indexOf("@mail") != -1){
                    subdomain = email.replace('.','').split(':').pop().split('@')[0];

                } else {
                    subdomain = email.split(':').pop().split('@')[1];
                    subdomain = subdomain.split('.')[0];
                }

                if(url.indexOf("localhost") != -1){
                    window.location.href = "http://"+subdomain+".localhost:8888/admin/users/login?u="+email;
                } else {
                    window.location.href = "https://"+subdomain+".onboardio.pro/admin/users/login?u="+email;
                }


            },
            changeLang(lang){
                this.lang = lang;
                this.checkTenancy();
                document.cookie = "loginLang="+lang+";path=/";
            },
            getCookie(cname) {
              let name = cname + "=";
              let ca = document.cookie.split(';');
              for(let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                  c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                  return c.substring(name.length, c.length);
                }
              }
              return "";
            }



        }
    }
</script>
